import React, { useEffect, useState } from "react";
import SvgIcn from "../../data/IconCompo";
import countries from "../../data/countries.json";
import CountryFlag from "../../data/IconCountry";

const SOCIAL_PLATFORM_ORDER = [
  "figma",
  "dribbble",
  "behance",
  "linkedin",
  "x",
  "instagram",
  "facebook",
  "tiktok",
];

const SOCIAL_ICON_BY_PLATFORM = {
  figma: "figma_line",
  dribbble: "dribbble_line",
  behance: "behance_line",
  linkedin: "linkedin_line",
  x: "twitter_line",
  instagram: "instagram_line",
  facebook: "facebook_line",
  tiktok: "tiktok_line",
};

const UserCard = ({
  data,
  visibleInputs,
  socialOrder,
  admin = false,
  showSocialPlaceholder = false,
}) => {
  const [country, setCountry] = useState();

  useEffect(() => {
    setCountry(countries.find((el) => el.value === data?.nationality));
  }, [data]);

  const normalizeUrl = (raw) => {
    if (raw == null) return "";
    const v = String(raw).trim();
    if (!v) return "";
    if (/^https?:\/\//i.test(v)) return v;
    return `https://${v}`;
  };

  const xUrl = normalizeUrl(data?.x || data?.twitter);
  const xVisible = Boolean(visibleInputs?.x || visibleInputs?.twitter);

  const socialUrlFor = (platform) => {
    if (platform === "x") return xUrl;
    return normalizeUrl(data?.[platform]);
  };

  const isSocialVisible = (platform) => {
    if (platform === "x") return xVisible;
    return Boolean(visibleInputs?.[platform]);
  };

  const orderedSocialPlatforms = (() => {
    const base =
      Array.isArray(socialOrder) && socialOrder.length > 0
        ? socialOrder
        : SOCIAL_PLATFORM_ORDER;
    const seen = new Set();
    const out = [];
    for (const p of base) {
      if (!SOCIAL_PLATFORM_ORDER.includes(p)) continue;
      if (!isSocialVisible(p)) continue;
      const url = socialUrlFor(p);
      if (!url) continue;
      if (seen.has(p)) continue;
      seen.add(p);
      out.push(p);
    }
    for (const p of SOCIAL_PLATFORM_ORDER) {
      if (seen.has(p)) continue;
      if (!isSocialVisible(p)) continue;
      const url = socialUrlFor(p);
      if (!url) continue;
      out.push(p);
    }
    return out;
  })();

  // Check if any social media links exist
  const hasSocialLinks = () => {
    return (
      data?.personalSite ||
      data?.personalBlog ||
      (visibleInputs?.figma && data?.figma) ||
      (xVisible && xUrl) ||
      (visibleInputs?.dribbble && data?.dribbble) ||
      (visibleInputs?.behance && data?.behance) ||
      (visibleInputs?.linkedin && data?.linkedin) ||
      (visibleInputs?.instagram && data?.instagram) ||
      (visibleInputs?.facebook && data?.facebook) ||
      (visibleInputs?.tiktok && data?.tiktok)
    );
  };

  return (
    <div className="user-card">
      <div className="photo">
        {data?.image ? (
          <img src={data?.image} alt="User" className="img" />
        ) : (
          <div className="avatar-skl">
            <SvgIcn name="logo01" />
          </div>
        )}
        {country ? (
          <div
            className="country-flag-badge"
            title={country.label}
            aria-label={`Country: ${country.label}`}
          >
            <CountryFlag Name={country.iso2.toLowerCase()} className="flag" />
            <span className="country-flag-tooltip">{country.label}</span>
          </div>
        ) : null}
      </div>
      <div className="details">
        <h2 className="name">
          {data?.fullName || <div className="name-skl"></div>}
        </h2>
        <span className="role">
          {data?.subRole || <div className="role-skl"></div>}

         <span className="experience"> {data?.experience || <div className="exp-skl"></div>}</span>
        </span>
        <p className="username">
          <SvgIcn name="username" />
          {data?.username || <div className="username-skl"></div>}
        </p>
        {admin && <p>{data?.email}</p>}

        <p className="intro">
        {data?.intro || (
          <div className="intro-skl">
            <div className="intro-skl-lines"></div>
            <div className="intro-skl-lines"></div>
            <div className="intro-skl-lines"></div>
            <div className="intro-skl-lines"></div>
            <div className="intro-skl-lines"></div>
            <div className="intro-skl-lines"></div>
            {/* <div className="intro-skl-lines short"></div> */}
          </div>
        )}
      </p>

        <div className="social">
          {data?.personalSite && (
            <a
              href={normalizeUrl(data?.personalSite)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SvgIcn name="globe" />
            </a>
          )}
          {data?.personalBlog && (
            <a
              href={normalizeUrl(data?.personalBlog)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SvgIcn name="blog_line" />
            </a>
          )}
          {orderedSocialPlatforms.map((platform) => {
            const href = socialUrlFor(platform);
            const icon = SOCIAL_ICON_BY_PLATFORM[platform];
            if (!icon) return null;
            return (
              <a
                key={platform}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SvgIcn name={icon} />
              </a>
            );
          })}
          {showSocialPlaceholder && !hasSocialLinks() && (
            <>
              <div className="social-skl"></div>
              <div className="social-skl"></div>
              <div className="social-skl"></div>
              <div className="social-skl"></div>
              <div className="social-skl"></div>
            </>
          )}
        </div>
      </div>


    </div>
  );
};

export default UserCard;
